module.exports = __webpack_public_path__ + "img/anju-official-account.f986b066.jpg";